import MusicNoteIcon from '@mui/icons-material/MusicNote';
import HomeIcon from '@mui/icons-material/Home';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import ShortTextIcon from '@mui/icons-material/ShortText';

export const categories = [
    { name: 'Home', icon: <HomeIcon /> },
    { name: 'Hololive', icon: <HomeIcon /> },
    { name: 'Short', icon: <ShortTextIcon /> },
    { name: 'Music', icon: <MusicNoteIcon /> },
    { name: 'Trending', icon: <WhatshotIcon /> },
    { name: 'Gaming', icon: <SportsEsportsIcon /> },
    { name: 'Live', icon: <LiveTvIcon /> },
    { name: 'Fashion', icon: <CheckroomIcon /> },
    { name: 'Sports', icon: <SportsSoccerIcon /> },
    { name: 'Gym', icon: <FitnessCenterIcon /> },
    { name: 'Podcast', icon: <GraphicEqIcon /> },
    { name: 'English', icon: <DeveloperModeIcon /> },
    { name: 'News', icon: <NewspaperIcon /> },
];
